import '../../App.scss'
import React, { Component } from 'react'
import Highlight from '../home/Highlight'
import collection from '../../data/library'

export default class News extends Component {
    constructor(props) {
        super(props);
        this.state = {
           content: ['']
        };
    }
    componentDidMount(){
        this.setState({
            content: collection.content
        })
        // console.log(collection)
    }
    render(){

        return (
          <div className="Library">
           <div className="TopBar">
              <div className="TopDivider">
              <div className="SearchBar">
                        <h1>Archaeology In the News</h1>
                            <div className="AboutTop">
                                <p>This page displays a list of external articles that might be interesting to people following AHRF.</p>
                            </div>
                        </div>
              </div>
           </div>
                {this.state.content.map((info,index)=>(
            <Highlight 
            content={info} />
        
        ))} 
          </div>
        );
    }
}
